export const genderKeys = {
  male: "male",
  female: "female",
};

export const bodyKeys = {
  slim: "slim",
  curve: "curve",
};

export const stylizationKeys = {
  no: "no",
  glamour: "glamour",
};

export const contextTypeKeys = {
  template: "template",
  original: "original",
};

export const extraKeys = {
  version: "version",
  concurrency: "concurrency",
  gender: "gender",
  body: "body",
  stylization: "stylization",
  contextType: "context_type",
  sectionName: "section_name",
  sectionPosition: "section_position",
  blockName: "block_name",
  blockPosition: "block_position",
  skipBodyCheck: "skip_body_check",
  selectedHairColor: "selected_hair_color",
  selectedHairStyle: "selected_hair_style",
  answers: "answers",
  collageType: "collage_type",
  isNsfw: "is_nsfw",
  retries: "retries",
  retriesMax: "retries_max",
  badResultRetries: "bad_result_retries",
  badResultRetriesMax: "bad_result_retries_max",
  seeds: "seeds",
  config: "config",
  isPaid: "is_paid",
  isPayable: "is_payable",
  position: "position"
};

export const ageGroups = [
  {
    id: "kid",
    range: [0, 9],
    value: {
      [genderKeys.male]: "small 5 years old child boy",
      [genderKeys.female]: "small 5 years old child girl"
    }
  },
  {
    id: "teenager",
    range: [10, 19],
    value: {
      [genderKeys.male]: "15 years old teenager male",
      [genderKeys.female]: "13 years old teenager female"
    }
  },
  {
    id: "young",
    range: [20, 24],
    value: {
      [genderKeys.male]: "young male",
      [genderKeys.female]: "young female"
    }
  },
  {
    id: "adult",
    range: [25, 49],
    value: {
      [genderKeys.male]: "adult male",
      [genderKeys.female]: "female"
    }
  },
  {
    id: "mature",
    range: [50, 69],
    value: {
      [genderKeys.male]: "40 years old mature male",
      [genderKeys.female]: "40 years old woman"
    }
  },
  {
    id: "old",
    range: [70, 999],
    value: {
      [genderKeys.male]: "old grandfather with old body",
      [genderKeys.female]: "old grandmother with old body"
    }
  },
];